export default "__VITE_ASSET__DmxOj0fl__"